import { Popover } from 'antd';
import Icon from 'assets/Icons';
import { CALENDAR_ITEM_TYPES } from 'features/appointment/services/constants';
import { ICalendarHeader, ICalendarItemData } from 'features/appointment/services/types/calendar';
import { get } from 'lodash';
import React, { useMemo } from 'react';
import { styled } from 'styled-components';
import Appointment from './Appointment';
import BlockHour from './BlockHour';
import BreakStaff from './BreakStaff';
import MultiAppointment from './MultiAppointment';
import MultipleAppointmentV2 from './MultipleAppointmentV2';
import SplitBlockColumn from './SplitBlockColumn';
type ICalendarItemProps = {
  data: ICalendarItemData[];
  headerData?: ICalendarHeader;
  isMonthView?: boolean;
  dateOfMonth?: string;
  v2?: boolean;
};
const CalendarItem: React.FC<ICalendarItemProps> = ({ v2, data, headerData, isMonthView, dateOfMonth }) => {
  const appointments = useMemo(() => data.filter(o => o.type === CALENDAR_ITEM_TYPES.APPOINTMENT), [data]);

  const lockTimes = useMemo(() => data.filter(o => o.type === CALENDAR_ITEM_TYPES.BLOCK_HOURS), [data]);
  const breakStaffs = useMemo(() => data.filter(o => o.type === CALENDAR_ITEM_TYPES.BREAK_STAFF), [data]);

  const contentBreakTime = useMemo(() => {
    if (!breakStaffs?.length) return null;
    return (
      <ContentStyled>
        <BreakStaff data={breakStaffs} isMonthView={isMonthView} headerData={headerData} />
      </ContentStyled>
    );
  }, [breakStaffs]);

  const Appointments = () => {
    if (appointments.length > 1) {
      return (
        <MultipleAppointmentV2
          headerData={headerData}
          data={appointments}
          isMonthView={isMonthView}
          dateOfMonth={dateOfMonth}
          v2
        />
      );
    }
    return (
      <Appointment
        headerData={headerData}
        data={get(appointments, [0])}
        isMonthView={isMonthView}
        dateOfMonth={dateOfMonth}
        v2={v2}
      />
    );
  };

  const blockItems = useMemo(() => [...lockTimes, ...breakStaffs], [lockTimes, breakStaffs]);

  if (appointments.length > 0 && blockItems.length > 0) {
    return <CalendarItemStyled isMonthView={isMonthView}>
      <SplitBlockColumn
        blockItems={blockItems}
        appointments={appointments}
        headerData={headerData}
        isMonthView={isMonthView}
        v2={v2}
      />
    </CalendarItemStyled>;
  }

  if (appointments?.length > 0) {
    return <CalendarItemStyled isMonthView={isMonthView}>
      <Appointments />
    </CalendarItemStyled>;
  }

  if (lockTimes?.length > 0) {
    return <CalendarItemStyled isMonthView={isMonthView}>
      {(breakStaffs.length > 0) ? <div className="top">
        <Popover content={contentBreakTime} trigger={['click']}>
          <button><Icon type='exclamationCircle' /></button>
        </Popover>
      </div> : null}
      {lockTimes?.length > 0 ? <BlockHour data={lockTimes} isMonthView={isMonthView} dateOfMonth={dateOfMonth} headerData={headerData} /> : null}
    </CalendarItemStyled>;
  }

  return <CalendarItemStyled isMonthView={isMonthView}>
    {lockTimes?.length > 0 ? <BlockHour data={lockTimes} isMonthView={isMonthView} dateOfMonth={dateOfMonth} headerData={headerData} /> : null}
    {breakStaffs?.length > 0 ? <BreakStaff data={breakStaffs} isMonthView={isMonthView} dateOfMonth={dateOfMonth} headerData={headerData} /> : null}
  </CalendarItemStyled>;
};

export default React.memo(CalendarItem);
type CalendarItemStyledProps = {
  isMonthView?: boolean;
};
const CalendarItemStyled = styled.div<CalendarItemStyledProps>`
  height: 100%;
  width: 100%;
  position:relative;
  .top {
    position: absolute;
    top: -10px;
    right:-10px;
    z-index: 1;
  }
`;

const ContentStyled = styled.div`
  display:flex;
  flex-direction: column;
  gap:12px;
  height: 8rem;
  width: 15rem;
  margin-bottom: 1rem;
`;